import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable()
export class HttpClientService {
  BASE_URL: string = environment.apiBaseUrl;
  constructor(private http: HttpClient) { }

  // get<T>(url: string, data: any = {}) {
  //   url = this.BASE_URL + url;
  //   let headers = new HttpHeaders({
  //     'Authorization': `${localStorage.getItem('token') || ''}`
  //   })
  //   return this.http.get<T>(url, { headers });
  // }
  // put<T>(url: string, data: any = {}) {
  //   url = this.BASE_URL + url;
  //   let headers = new HttpHeaders({
  //     'Authorization': `${localStorage.getItem('token')}`
  //   })
  //   return this.http.put<T>(url, data, { headers });
  // }
  // remove<T>(url: string) {
  //   url = this.BASE_URL + url;
  //   let headers = new HttpHeaders({
  //     'Authorization': `${localStorage.getItem('token')}`
  //   })
  //   return this.http.delete<T>(url, { headers });
  // }
  // post<T>(url: string, data: any, header = {}) {
  //   url = this.BASE_URL + url;
  //   let headers = new HttpHeaders({
  //     ...header,
  //     'Authorization': `${localStorage.getItem('token')}`
  //   })
  //   return this.http.post<T>(url, data, { headers });
  // }

  get<T>(url: string, data: any = {}) {
    url = this.BASE_URL + url;
    return this.http.get<T>(url);
  }
  put<T>(url: string, data: any = {}) {
    url = this.BASE_URL + url;
    return this.http.put<T>(url, data);
  }
  remove<T>(url: string) {
    url = this.BASE_URL + url;
    return this.http.delete<T>(url);
  }
  post<T>(url: string, data: any, header = {}) {
    url = this.BASE_URL + url;
    return this.http.post<T>(url, data);
  }

}
